export const actionOfAddScreenWidth = (value) => ({
  type: "screen/ADD_SCREEN_WIDTH",
  payload:value
});

export const actionOfAddScreenDeviceType = (value) => ({
  type: "screen/ADD_SCREEN_DEVICE_TYPE",
  payload:value
});
